import { useState, useCallback } from 'react';
import { TRANSACTION_CONFIG } from '../../../utils/common';
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';

export interface TransactionData {
  voucherType: string;
  voucherId: number;
  voucherNumber: string;
  accountid: number | null;  
}

interface UseSetOffModalReturn {
  isOpen: boolean;
  transactionData: TransactionData | null;
  openModal: (voucherType: string, voucherId: number, voucherNumber: string, accountid: number) => void;
  closeModal: () => void;
}

export const useSetOffModal = (): UseSetOffModalReturn => {
  const [isOpen, setIsOpen] = useState(false);
  const [transactionData, setTransactionData] = useState<TransactionData | null>(null);

  const openModal = useCallback((voucherType: string, voucherId: number, voucherNumber: string, accountid: number | null) => {
    // Validate required fields
    if (!voucherType) {
      showWarningSnackbar('Voucher type is required to open Set-Off modal');
      return;
    }

    if (!voucherId) {
      showWarningSnackbar('Voucher ID is required to open Set-Off modal');
      return;
    }

    if (!voucherNumber) {
      showWarningSnackbar('Voucher number is required to open Set-Off modal');
      return;
    }

    // Validate voucher type exists in TRANSACTION_CONFIG
    const config = TRANSACTION_CONFIG[voucherType as keyof typeof TRANSACTION_CONFIG];
    if (!config) {
      showWarningSnackbar(`Invalid voucher type: ${voucherType}`);
      return;
    }

    // Create validated data
    const validatedData: TransactionData = {
      voucherType,
      voucherId,
      voucherNumber,
      accountid,
    };

    setTransactionData(validatedData);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setTransactionData(null);
  }, []);

  return {
    isOpen,
    transactionData,
    openModal,
    closeModal,
  };
};
